import { formatDateUTC, formatTimeUTC } from '../helpers/dateFormatter'

const time = document.querySelectorAll('[data-time]')
const date = document.querySelectorAll('[data-date]')

time.forEach(element => {
  const dateString = element.getAttribute('data-time')
  element.textContent = formatTimeUTC(dateString)
})

date.forEach(element => {
  const dateString = element.getAttribute('data-date')
  element.textContent = formatDateUTC(dateString, true)
})
